import script from "./rescheduleRequestDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./rescheduleRequestDetails.vue?vue&type=script&setup=true&lang=js"

import "./rescheduleRequestDetails.vue?vue&type=style&index=0&id=2dccca64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dccca64"]])

export default __exports__